module.exports = __webpack_public_path__ + "static/img/28.cdd57582.png";